import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'
import { CPIColor } from 'lib/utils'
import { useThemeColors } from 'hooks/useThemeColors'

const Container = styled(Box)<{ containerType: 'info' | 'error' }>`
  border-radius: ${theme.attributes.borderRadius.secondary};
  border: 1px solid ${theme.colors.tooltipBg};
  background: ${theme.colors.tooltipBg};
  box-shadow: ${theme.attributes.boxShadow.toolbar};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.small}px;
  padding: ${theme.spacing.small}px;
  height: 56px;
  width: 255px;
  min-width: 255px;

  img {
    min-width: 24px;
    min-height: 24px;
  }

  ${({ containerType }) =>
    containerType === 'error' &&
    `
      border: 1px solid ${theme.colors.tooltipBg};
      background: ${CPIColor.Problematic};
    `};

  .total-info-text {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: normal;
    white-space: nowrap;
  }
`

interface Props {
  type: 'info' | 'error'
}

const TotalMustEqual: FC<Props> = ({ type = 'info' }) => {
  const getColor = useThemeColors()

  return (
    <Container className="total-info-wrapper" containerType={type}>
      {type === 'info' ? (
        <svg width="24" height="24" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.33325 5.16683H8.66659V6.50016H7.33325V5.16683ZM7.33325 7.8335H8.66659V11.8335H7.33325V7.8335ZM7.99992 1.8335C4.31992 1.8335 1.33325 4.82016 1.33325 8.50016C1.33325 12.1802 4.31992 15.1668 7.99992 15.1668C11.6799 15.1668 14.6666 12.1802 14.6666 8.50016C14.6666 4.82016 11.6799 1.8335 7.99992 1.8335ZM7.99992 13.8335C5.05992 13.8335 2.66659 11.4402 2.66659 8.50016C2.66659 5.56016 5.05992 3.16683 7.99992 3.16683C10.9399 3.16683 13.3333 5.56016 13.3333 8.50016C13.3333 11.4402 10.9399 13.8335 7.99992 13.8335Z"
            fill={getColor('cta')}
          />
        </svg>
      ) : (
        <img src="/error-icon.svg" alt="error" width="24px" height="24px" />
      )}
      <Typography className="total-info-text">Total must equal 100%.</Typography>
    </Container>
  )
}

export default TotalMustEqual
